module.exports = __webpack_public_path__ + "img/carrito-compra-boton.921e4a59.svg";